const traverseObject = <T extends { [key: string]: any }>(
    object: T,
    traverseKey: string // in the form of "{key_1}: ... : {key_n}"
) => {
    try {
        const splitKey = traverseKey.split(":");
        return splitKey.reduce((acc, curr) => acc[curr], object);
    } catch (e) {
        return null;
    }
};

export default traverseObject;
